<template>
  <div class="product-attributes">
    <div class="page-header">
      <h2>商品属性</h2>
    </div>
    
    <a-tabs v-model:activeKey="activeTab" @change="handleTabChange">
      <a-tab-pane key="color" tab="颜色管理">
        <AttributePanel
          :type="'color'"
          :attributes="colorAttributes"
          :loading="loading"
          @save="handleSave"
          @add="handleAdd"
        />
      </a-tab-pane>
      
      <a-tab-pane key="size" tab="尺寸管理">
        <AttributePanel
          :type="'size'"
          :attributes="sizeAttributes"
          :loading="loading"
          @save="handleSave"
          @add="handleAdd"
        />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { message } from 'ant-design-vue'
import { productApi } from '@/api'
import AttributePanel from './components/AttributePanel.vue'

export default {
  name: 'ProductAttributes',
  components: {
    AttributePanel
  },
  setup() {
    const loading = ref(false)
    const activeTab = ref('color')
    const colorAttributes = ref([])
    const sizeAttributes = ref([])
    
    const loadAttributes = async (type) => {
      loading.value = true
      try {
        const result = await productApi.getAttributes(type)
        const attributes = result.data || []
        
        if (type === 'color') {
          colorAttributes.value = attributes
        } else if (type === 'size') {
          sizeAttributes.value = attributes
        }
      } catch (error) {
        console.error(`加载${type === 'color' ? '颜色' : '尺寸'}属性失败:`, error)
        message.error(`加载${type === 'color' ? '颜色' : '尺寸'}属性失败`)
      } finally {
        loading.value = false
      }
    }
    
    const handleTabChange = (key) => {
      activeTab.value = key
      loadAttributes(key)
    }
    
    const handleSave = async (type, attributes) => {
      loading.value = true
      try {
        const filteredAttributes = attributes.filter(attr => attr.value && attr.value.trim())
        
        const requestData = {
          attributes: filteredAttributes.map(attr => ({
            type: type,
            value: attr.value.trim(),
            orderNum: attr.orderNum
          }))
        }
        
        await productApi.batchUpdateAttributes(requestData)
        message.success(`${type === 'color' ? '颜色' : '尺寸'}属性保存成功`)
        
        // 重新加载数据
        loadAttributes(type)
      } catch (error) {
        console.error('保存属性失败:', error)
        message.error(`保存${type === 'color' ? '颜色' : '尺寸'}属性失败`)
      } finally {
        loading.value = false
      }
    }
    
    const handleAdd = (type) => {
      const currentAttributes = type === 'color' ? colorAttributes.value : sizeAttributes.value
      const maxOrderNum = Math.max(0, ...currentAttributes.map(attr => attr.orderNum || 0))
      
      const newAttribute = {
        type: type,
        value: '',
        orderNum: maxOrderNum + 1,
        isNew: true
      }
      
      if (type === 'color') {
        colorAttributes.value.push(newAttribute)
      } else {
        sizeAttributes.value.push(newAttribute)
      }
    }
    
    
    onMounted(() => {
      loadAttributes('color')
    })
    
    return {
      loading,
      activeTab,
      colorAttributes,
      sizeAttributes,
      handleTabChange,
      handleSave,
      handleAdd
    }
  }
}
</script>

<style scoped>
.product-attributes {
  padding: 0;
}

.page-header {
  margin-bottom: 24px;
}

.page-header h2 {
  margin: 0;
}
</style>